export default function Program() {
  const programs = [
    {
      icon: 'ri-chat-3-line',
      title: 'Développement du langage',
      description: 'Contes, chansons et discussions pour enrichir le vocabulaire et la communication',
      image: 'https://public.readdy.ai/ai/img_res/9122483768309d67884ab02182124c06.jpg',
      gradient: 'from-orange-400 to-red-500'
    },
    {
      icon: 'ri-run-line',
      title: 'Motricité fine et globale',
      description: 'Jeux extérieurs, bricolage, danse et yoga pour développer les capacités motrices',
      image: 'https://readdy.ai/api/search-image?query=Happy%20children%20doing%20yoga%20and%20physical%20activities%20in%20modern%20daycare%20center%20with%20colorful%20mats%20exercise%20equipment%20bright%20natural%20lighting%20professional%20childcare%20setting%20healthy%20development&width=400&height=300&seq=motor-skills&orientation=landscape',
      gradient: 'from-orange-400 to-red-500'
    },
    {
      icon: 'ri-palette-line',
      title: 'Créativité et imagination',
      description: 'Arts plastiques, théâtre et musique pour stimuler la créativité',
      image: 'https://readdy.ai/api/search-image?query=Children%20engaged%20in%20creative%20art%20activities%20painting%20drawing%20crafts%20in%20colorful%20daycare%20classroom%20with%20art%20supplies%20easels%20creative%20materials%20bright%20cheerful%20atmosphere%20professional%20childcare&width=400&height=300&seq=creativity&orientation=landscape',
      gradient: 'from-orange-400 to-red-500'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Autonomie et confiance',
      description: 'Responsabilités quotidiennes et routines pour développer l\'indépendance',
      image: 'https://readdy.ai/api/search-image?query=Young%20children%20learning%20independence%20and%20self-care%20skills%20in%20modern%20daycare%20setting%20with%20child-sized%20furniture%20educational%20toys%20bright%20clean%20environment%20professional%20childcare%20atmosphere&width=400&height=300&seq=autonomy&orientation=landscape',
      gradient: 'from-orange-400 to-red-500'
    },
    {
      icon: 'ri-team-line',
      title: 'Socialisation',
      description: 'Jeux coopératifs, partages et résolution de conflits pour apprendre le vivre-ensemble',
      image: 'https://readdy.ai/api/search-image?query=Group%20of%20diverse%20children%20playing%20together%20cooperatively%20sharing%20toys%20in%20bright%20modern%20daycare%20classroom%20with%20educational%20games%20colorful%20environment%20professional%20childcare%20setting%20social%20development&width=400&height=300&seq=socialization&orientation=landscape',
      gradient: 'from-orange-400 to-red-500'
    }
  ];

  return (
    <section id="programme" className="py-20 bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-graduation-cap-line text-white text-2xl"></i>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Notre programme éducatif
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Inspiré du programme éducatif du Ministère de la Famille, notre approche repose sur le jeu, la découverte et la participation active des enfants.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {programs.map((program, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow group">
              <div className="h-48 w-full overflow-hidden">
                <img 
                  src={program.image}
                  alt={program.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className={`w-12 h-12 bg-gradient-to-br ${program.gradient} rounded-full flex items-center justify-center mb-4`}>
                  <i className={`${program.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  {program.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {program.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
